import React, { useState, useEffect } from 'react';
import UploadFiles from './UploadFiles';

const ItemCheckList = ({item, defaultProps, handleItemOk}) => {
  // CONFIG PROPS
  const {nome, quantidade, obrigatorio, ordem} = item;
  const requiredFiles                          = obrigatorio === 'true';
  defaultProps.requiredFiles                   = requiredFiles;
  defaultProps.maxFiles                        = quantidade;
  defaultProps.compOrder                       = ordem + 1;

  const [itemOk, setItemOk] = useState(defaultProps.requiredFiles === false);
  // EFFECT TO STATE UPLOAD ALL REQUIRED FILES
  useEffect(() => {
    if (handleItemOk) {
      handleItemOk(item, itemOk);
    }

    return () => {};
  }, [itemOk, handleItemOk]);

  const handleUploadAllRequiredFiles = (bool) => {
    setItemOk(bool);
  };

  // RETURN ITEM CHECK LIST
  return <>
    <div className="bg-dark text-white">
      <div className="p-2">{ordem + 1}º: {nome}</div>
      <div className="px-1">Quantidade: {quantidade}</div>
      <div className="px-1">Obrigatório: {requiredFiles ? 'sim' : 'nao'}</div>
      <div className="bg-white">
        <UploadFiles
          {...defaultProps}
          handleUploadAllRequiredFiles={handleUploadAllRequiredFiles}
        />
      </div>
    </div>
  </>;
};

export default React.memo(ItemCheckList);
